import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { LetDirective } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';

import { AlertModule } from '@personal-area/global/ui'
import { ButtonComponent } from '@personal-area/global/ui'
import { InputChipComponent } from '@personal-area/global/ui';
import { IconSpriteModule } from '@personal-area/icon-sprite';

import { LeveragePopupComponent } from './leverage-popup.component';

@NgModule({
  declarations: [LeveragePopupComponent],
  exports: [LeveragePopupComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ButtonComponent,
    LetDirective,
    MatDialogModule,
    IconSpriteModule,
    AlertModule,
    InputChipComponent,
  ],
})
export class LeveragePopupModule {
}
